var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, -9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0622 9.56678C20.0622 14.7754 15.7823 19.0001 10.5 19.0001C5.21769 19.0001 0.93783 14.7754 0.93783 9.56678C0.93783 4.35816 5.21769 0.133447 10.5 0.133447C15.7823 0.133447 20.0622 4.35816 20.0622 9.56678Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9 12.0908C24.9 13.6949 24.5535 15.0034 23.9314 16.065C23.3093 17.1266 22.4082 17.947 21.2902 18.5695C19.0508 19.8165 15.9466 20.2667 12.5 20.2667C9.05336 20.2667 5.94924 19.8165 3.70981 18.5695C2.5918 17.947 1.6907 17.1266 1.06859 16.065C0.446455 15.0034 0.1 13.6949 0.1 12.0908C0.1 5.67694 5.64554 0.466699 12.5 0.466699C19.3545 0.466699 24.9 5.67694 24.9 12.0908Z",
    fill: "#C4C4C4",
    stroke: "#C4C4C4",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.d4c5ab39861e5b970ae87ae47c61be3d.svg";
export { ForwardRef as ReactComponent };